/* global axios */
import ApiClient from './ApiClient';

class BotsAPI extends ApiClient {
  constructor() {
    super('bots', { accountScoped: true });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  toggleActive(id) {
    return axios.post(`${this.url}/${id}/toggle_active`);
  }

  launch(id, conversationId) {
    return axios.post(`${this.url}/${id}/launch`, { conversation_id: conversationId });
  }

  importKommo({ json_data, dry_run = false }) {
    return axios.post(`${this.url}/import_kommo`, { json_data, dry_run });
  }

  // ── Triggers ────────────────────────────────────────────────
  triggers(botId) {
    return axios.get(`${this.url}/${botId}/triggers`);
  }
  createTrigger(botId, payload, extra = {}) {
    // V4 · multi-etapa: `linked_group_id` se manda como param top-level si
    // queremos AGREGAR un trigger a un grupo ya existente (no generar UUID nuevo).
    return axios.post(`${this.url}/${botId}/triggers`, { trigger: payload, ...extra });
  }
  updateTrigger(botId, id, payload) {
    // payload puede incluir `propagate_to_linked: true/false` para grupos enlazados.
    // Lo extraemos del payload para enviarlo como top-level param (no anidado en trigger).
    const propagate = payload?.propagate_to_linked;
    const cleanPayload = { ...payload };
    delete cleanPayload.propagate_to_linked;
    const body = { trigger: cleanPayload };
    if (propagate !== undefined) body.propagate_to_linked = !!propagate;
    return axios.patch(`${this.url}/${botId}/triggers/${id}`, body);
  }
  deleteTrigger(botId, id, opts = {}) {
    // `delete_all_linked: true` → elimina todos los del grupo enlazado.
    const params = opts.delete_all_linked ? { delete_all_linked: true } : {};
    return axios.delete(`${this.url}/${botId}/triggers/${id}`, { params });
  }

  // ── Steps ───────────────────────────────────────────────────
  steps(botId) {
    return axios.get(`${this.url}/${botId}/steps`);
  }
  createStep(botId, payload) {
    return axios.post(`${this.url}/${botId}/steps`, { step: payload });
  }
  updateStep(botId, id, payload) {
    return axios.patch(`${this.url}/${botId}/steps/${id}`, { step: payload });
  }
  deleteStep(botId, id) {
    return axios.delete(`${this.url}/${botId}/steps/${id}`);
  }
}

export default new BotsAPI();
